import { useState } from 'react';

import { Button, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import SearchArticle from '../search-article';

/**
 * @param {Object} props
 * @param {Function} props.onSelect - Madde seçildiğinde çağrılacak callback.
 * @param {boolean} [props.isSelecting=false] - İlişki grubu oluşturma isteği devam ederken true olur; Select'i disabled/loading yapar.
 */
const AddNewRelationGroup = ({ onSelect, isSelecting = false }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        className="gx-d-flex gx-align-items-center"
        onClick={() => setOpen(true)}
        icon={<PlusOutlined />}
      >
        Yeni İlişkili Madde Ekle
      </Button>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={700}
        destroyOnClose
      >
        <div className="gx-d-flex  gx-flex-column">
          <h2 className="gx-fs-lg">Yeni İlişkili Madde Ekle</h2>
          <p className="gx-mb-0 gx-fs-sm">Veritabanından madde seçerek listeye ekleyebilirsiniz</p>
        </div>
        <SearchArticle onSelect={onSelect} isSelecting={isSelecting} autoFocus />
      </Modal>
    </>
  );
};

export default AddNewRelationGroup;
